import { z } from 'zod';
import { colorSchema, idSchema, mmSchema } from './common.js';
import { fontRefSchema } from './fonts.js';
import { itemSchema } from './items.js';
import { richTextSchema } from './text.js';
// ---------------------------------------------------------------------------
// Seitenrahmen (A.3)
// ---------------------------------------------------------------------------
export const frameBlockSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('name'), label: z.string() }),
    z.object({ kind: z.literal('date'), label: z.string() }),
    z.object({ kind: z.literal('class'), label: z.string() }),
    z.object({ kind: z.literal('pageNumber'), format: z.enum(['n', 'n/m']) }),
    z.object({ kind: z.literal('title') }),
    z.object({ kind: z.literal('text'), content: richTextSchema }),
    z.object({ kind: z.literal('image'), assetId: idSchema }),
    z.object({
        kind: z.literal('selfAssessment'),
        style: z.enum(['smileys', 'stars', 'traffic']),
    }),
]);
export const frameRowSchema = z.object({ blocks: z.array(frameBlockSchema) });
export const pageFrameSchema = z.object({
    id: idSchema,
    name: z.string().min(1),
    header: z.array(frameRowSchema).default([]),
    footer: z.array(frameRowSchema).default([]),
    /** 1 = keine Unterteilung in Aufgabenblöcke. */
    taskBlocks: z.number().int().min(1),
    pointsColumn: z.object({ enabled: z.boolean(), sumInFooter: z.boolean() }),
    lines: z
        .array(z.object({
        id: z.string().min(1),
        visible: z.boolean(),
        weight: z.number().positive(),
        color: colorSchema,
    }))
        .default([]),
    font: fontRefSchema,
    fontSize: z.number().positive(),
});
// ---------------------------------------------------------------------------
// Seite (A.3)
// ---------------------------------------------------------------------------
export const layoutGuideSchema = z.object({
    id: idSchema,
    axis: z.enum(['horizontal', 'vertical']),
    position: mmSchema,
    printable: z.boolean(),
});
export const pageSchema = z.object({
    id: idSchema,
    frameId: idSchema.optional(),
    /** Reihenfolge = Ebenen, hinten → vorne. */
    items: z.array(itemSchema).default([]),
    guides: z.array(layoutGuideSchema).default([]),
    /** Lehrerhinweis, wird nie gedruckt. */
    teacherNote: richTextSchema.optional(),
    digital: z.object({ isCoverPage: z.boolean().optional() }).optional(),
});
//# sourceMappingURL=page.js.map